/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractBalanceResponseDto
 */
export interface ContractBalanceResponseDto {
    /**
     * Share of premium signed
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * GST on premium
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    gstOnPremium: string;
    /**
     * Ceding commission
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    cedingCommission: string;
    /**
     * GST on ceding commission
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    gstOnCedingCommission: string;
    /**
     * Source brokerage
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    sourceBrokerage: string;
    /**
     * GST on source brokerage
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    gstOnSourceBrokerage: string;
    /**
     * ERE (Earthquake and related expenses)
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    ere: string;
    /**
     * Withholding tax
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    withholdingTax: string;
    /**
     * Net premium due from broker
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    netPremiumDueFromBroker: string;
    /**
     * Pinnacle commission
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    pinnacleCommission: string;
    /**
     * AIT (Additional Insurance Tax)
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    ait: string;
    /**
     * Taxes and fees
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    taxesAndFees: string;
    /**
     * Binder cash remittance
     * @type {string}
     * @memberof ContractBalanceResponseDto
     */
    binderCashRemittance: string;
}

/**
 * Check if a given object implements the ContractBalanceResponseDto interface.
 */
export function instanceOfContractBalanceResponseDto(value: object): value is ContractBalanceResponseDto {
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    if (!('gstOnPremium' in value) || value['gstOnPremium'] === undefined) return false;
    if (!('cedingCommission' in value) || value['cedingCommission'] === undefined) return false;
    if (!('gstOnCedingCommission' in value) || value['gstOnCedingCommission'] === undefined) return false;
    if (!('sourceBrokerage' in value) || value['sourceBrokerage'] === undefined) return false;
    if (!('gstOnSourceBrokerage' in value) || value['gstOnSourceBrokerage'] === undefined) return false;
    if (!('ere' in value) || value['ere'] === undefined) return false;
    if (!('withholdingTax' in value) || value['withholdingTax'] === undefined) return false;
    if (!('netPremiumDueFromBroker' in value) || value['netPremiumDueFromBroker'] === undefined) return false;
    if (!('pinnacleCommission' in value) || value['pinnacleCommission'] === undefined) return false;
    if (!('ait' in value) || value['ait'] === undefined) return false;
    if (!('taxesAndFees' in value) || value['taxesAndFees'] === undefined) return false;
    if (!('binderCashRemittance' in value) || value['binderCashRemittance'] === undefined) return false;
    return true;
}

export function ContractBalanceResponseDtoFromJSON(json: any): ContractBalanceResponseDto {
    return ContractBalanceResponseDtoFromJSONTyped(json, false);
}

export function ContractBalanceResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractBalanceResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'gstOnPremium': json['gstOnPremium'],
        'cedingCommission': json['cedingCommission'],
        'gstOnCedingCommission': json['gstOnCedingCommission'],
        'sourceBrokerage': json['sourceBrokerage'],
        'gstOnSourceBrokerage': json['gstOnSourceBrokerage'],
        'ere': json['ere'],
        'withholdingTax': json['withholdingTax'],
        'netPremiumDueFromBroker': json['netPremiumDueFromBroker'],
        'pinnacleCommission': json['pinnacleCommission'],
        'ait': json['ait'],
        'taxesAndFees': json['taxesAndFees'],
        'binderCashRemittance': json['binderCashRemittance'],
    };
}

export function ContractBalanceResponseDtoToJSON(json: any): ContractBalanceResponseDto {
    return ContractBalanceResponseDtoToJSONTyped(json, false);
}

export function ContractBalanceResponseDtoToJSONTyped(value?: ContractBalanceResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'gstOnPremium': value['gstOnPremium'],
        'cedingCommission': value['cedingCommission'],
        'gstOnCedingCommission': value['gstOnCedingCommission'],
        'sourceBrokerage': value['sourceBrokerage'],
        'gstOnSourceBrokerage': value['gstOnSourceBrokerage'],
        'ere': value['ere'],
        'withholdingTax': value['withholdingTax'],
        'netPremiumDueFromBroker': value['netPremiumDueFromBroker'],
        'pinnacleCommission': value['pinnacleCommission'],
        'ait': value['ait'],
        'taxesAndFees': value['taxesAndFees'],
        'binderCashRemittance': value['binderCashRemittance'],
    };
}

